/* unplugin-vue-components disabled */import { render } from "./PlatformsTable.vue?vue&type=template&id=4e5b5788&ts=true"
import script from "./PlatformsTable.vue?vue&type=script&lang=ts"
export * from "./PlatformsTable.vue?vue&type=script&lang=ts"

import "./PlatformsTable.vue?vue&type=style&index=0&id=4e5b5788&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__